import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Tab from './Tab';

class Tabs extends Component {
  static propTypes = {
    className: PropTypes.string,
    tabs: PropTypes.array,
    activeTabTypes: PropTypes.func
  };

  static defaultProps = {
    className: 'tabs--horizontal-scroll'
  };

  state = {
    activeTab: 0,
    types: this.props.tabs[0] ? this.props.tabs[0].types : [] // eslint-disable-line react/no-unused-state
  };

  componentDidMount() {
    const { activeTabTypes, tabs } = this.props;
    const { activeTab } = this.state;

    if (activeTabTypes) activeTabTypes(tabs[activeTab]);
  }

  handleActiveTab = (nextActiveTab, nextTab) => {
    const { activeTabTypes } = this.props;
    const { activeTab } = this.state;

    if (nextActiveTab === activeTab) return;
    if (activeTabTypes) activeTabTypes(nextTab);

    this.setState({
      activeTab: nextActiveTab,
      types: nextTab.types // eslint-disable-line react/no-unused-state
    });
  };

  render() {
    const { className, tabs } = this.props;
    const { activeTab } = this.state;

    return (
      <nav className={classnames('tabs', className)}>
        <ul className='tabs__container container'>
          {tabs.map((tab, index) => {
            const isActive = activeTab === index;

            return (
              <Tab
                key={tab.title}
                active={isActive}
                onClick={() => this.handleActiveTab(index, tab)}
                title={tab.title}
              />
            );
          })}
        </ul>
      </nav>
    );
  }
}

export default Tabs;
